export default "__VITE_ASSET__mMGIRnYU__"